import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import StackingCard from '../../components/CardStack/Card/StackingCard';
import CardStack from '../../components/CardStack/CardStack';
import { Header } from '../../components/Onboarding/Header';
import { OnboardingBusInfo } from '../../components/Onboarding/Onboarding.BusInfo';
import { OnboardingPreferredName } from '../../components/Onboarding/Onboarding.PreferredName';
import { OnboardingTOU } from '../../components/Onboarding/Onboarding.TOU';
import { OnboardingDecoration } from '../../components/SettingsDecoration/OnboardingDecoration';
import { useOnboardingContext } from '../../context/OnboardingContext/OnboardingContext';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import styles from './styles';
export const OnboardingPage = () => {
    const { t: text } = useTranslation();
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const isTabletOrMobile = isTablet || !isDesktop;
    const { onboardingContextState: { step: onBoardingStep }, updateStep, } = useOnboardingContext();
    const [stepIndex, setStepIndex] = React.useState(0);
    useEffect(() => {
        if (onBoardingStep > 3) {
            updateStep(0);
        }
        /* not sure what the business reason to require localStorage, should be local variable so that it automatically
           returns to 0 when user leaves */
        return () => updateStep(0);
    }, []);
    useEffect(() => {
        setStepIndex(onBoardingStep > 3 || !onBoardingStep ? 0 : onBoardingStep);
    }, [onBoardingStep]);
    const onBoardingStepComponent = [
        [null],
        [_jsx(OnboardingTOU, {}), text('ONBOARDING_TOU_TITLE'), text('ONBOARDING_TOU_SUBTITLE')],
        [
            _jsx(OnboardingBusInfo, {}),
            text('ONBOARDING_BUS_INFO_TITLE'),
            text('ONBOARDING_BUS_INFO_DESCRIPTION'),
        ],
        [
            _jsx(OnboardingPreferredName, {}),
            text('ONBOARDING_CHANGE_NAME_TITLE'),
            text('ONBOARDING_CHANGE_NAME_SUBTITLE'),
        ],
    ];
    const OnBoardingComponent = stepIndex === 6 ? onBoardingStepComponent[0] : onBoardingStepComponent[stepIndex]; //|| onBoardingStepComponent[0];
    const decorationProps = stepIndex === 0 ? { asStandAlonePage: true } : {};
    return (_jsx(Box, { sx: { height: '100%' }, children: _jsx(Grid, { container: true, direction: 'column', rowSpacing: 3, sx: styles.main, children: _jsxs(CardStack, { children: [!isDesktop && OnBoardingComponent[1] && OnBoardingComponent[2] && (_jsx(Header, { title: OnBoardingComponent[1], subtitle: OnBoardingComponent[2] })), _jsx(StackingCard, { sectionName: 'Onboarding Splash', color: isDesktop ? '#FFFFFF' : '#E4EEEF', children: _jsxs(Box, { sx: styles.mainContent(isTabletOrMobile), children: [OnBoardingComponent[0], (!isTabletOrMobile || stepIndex === 0) && (_jsx(Box, { sx: styles.decorationWrapper(isTabletOrMobile, stepIndex === 0 ? true : false), children: _jsx(OnboardingDecoration, { ...decorationProps }) }))] }) })] }) }) }));
};
